// Size Guide modal open/close helpers. Moved verbatim out of
// snippets/size-guide-modal.liquid so it loads with `defer` instead of blocking
// the parser.
//
// CAVEAT: the modal markup triggers these via inline `onclick="openSizeGuideModal(...)"`
// / `onclick="closeSizeGuideModal(...)"` attributes, which need window.openSizeGuideModal
// and window.closeSizeGuideModal to exist. `defer` scripts run after parsing but
// before DOMContentLoaded, so there is a brief window on very slow devices where a
// tap on the size-guide button before this file executes would do nothing. Verify
// the size-guide button after deploying.
(function () {
  // Prevent multiple initializations
  if (window.sizeGuideModalInitialized) return;
  window.sizeGuideModalInitialized = true;

  // Store direct reference to the currently open modal (fixes duplicate ID issue)
  window.currentOpenSizeGuideModal = null;
  // Store permanent reference to the product page modal (the one with content)
  window.productPageSizeGuideModal = null;

  window.openSizeGuideModal = function (modalId = 'size-guide-modal', element) {
    const headerSection = document.querySelector('.header-section');

    if (element && element.closest('.quick-add-modal')) {
      return; // Prevent opening if inside quick-add-size
    }

    // If we already have a stored reference to the product page modal, reuse it
    let modal = window.productPageSizeGuideModal;

    // First time: find the modal with content (from product page)
    if (!modal) {
      // Try to find the modal inside .product-size-guide (the one with actual content)
      modal = document.querySelector('.product-size-guide #' + modalId);
      if (!modal) {
        // Fall back to first modal with that ID
        modal = document.getElementById(modalId);
      }
      // Store permanent reference so we always use the same modal
      window.productPageSizeGuideModal = modal;
    }

    if (modal) {
      // Move modal to body to escape any parent stacking contexts (only needed first time, but harmless to repeat)
      document.body.appendChild(modal);

      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      // Store direct reference to this modal for closing
      window.currentOpenSizeGuideModal = modal;

      if (headerSection) {
        headerSection.style.zIndex = '0';
      }

      // Focus management for accessibility
      const closeButton = modal.querySelector('button[aria-label="Close sizing guide"]');
      if (closeButton) {
        closeButton.focus();
      }
    }
  };

  window.closeSizeGuideModal = function (modalId = 'size-guide-modal') {
    // Use stored reference instead of getElementById (fixes duplicate ID bug)
    const modal = window.currentOpenSizeGuideModal;
    const headerSection = document.querySelector('.header-section');

    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
      window.currentOpenSizeGuideModal = null;
      // Note: we keep productPageSizeGuideModal so we can reuse it next time

      if (headerSection) {
        headerSection.style.zIndex = '99';
      }
    }
  };

  // Keyboard event handling for accessibility
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && window.currentOpenSizeGuideModal) {
      window.closeSizeGuideModal();
    }
  });
})();
